import {
  Component,
  input,
  output,
  signal,
  OnInit,
  OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { Subscription } from 'rxjs';

/**
 * DUMB COMPONENT: SeccionRiesgo
 *
 * Panel para indicar si se identificaron alertas tempranas de riesgo.
 * Solo visible para tipo CAMPO.
 *
 * Legacy: CreateOrUpdateCumplimientoViewImpl.ui.xml líneas 405-438
 * - Pregunta: ¿Identificó alertas tempranas de riesgo potencial?
 * - Campo: rbgIdentificaRiesgo (S/N)
 * - Cuando "Sí": Muestra panelInfoRiesgo con botón "REPORTAR ALERTA TEMPRANA"
 * - El botón abre URL externa (URL_ALERTA_TEM) con parámetros del beneficiario
 */
@Component({
  selector: 'app-seccion-riesgo',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FieldsetModule,
    RadioButtonModule,
    ButtonModule
  ],
  template: `
    <p-fieldset
      legend="¿Identificó alertas tempranas?"
      [toggleable]="true"
      styleClass="mb-4"
    >
      <div [formGroup]="form()">
        <div class="flex items-center gap-6">
          <div class="flex items-center gap-2">
            <p-radioButton
              formControlName="snidentificaRiesgo"
              value="S"
              inputId="riesgoSi"
              (onClick)="onRiesgoChange('S')"
            >
            </p-radioButton>
            <label for="riesgoSi" class="cursor-pointer">Sí</label>
          </div>
          <div class="flex items-center gap-2">
            <p-radioButton
              formControlName="snidentificaRiesgo"
              value="N"
              inputId="riesgoNo"
              (onClick)="onRiesgoChange('N')"
            >
            </p-radioButton>
            <label for="riesgoNo" class="cursor-pointer">No</label>
          </div>
        </div>

        <!-- Panel Registro de alertas tempranas (visible cuando "Sí") -->
        <!-- Legacy: panelInfoRiesgo con saNuevoRp (anchor) -->
        @if (mostrarPanelAlerta()) {
          <div
            class="mt-4 bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-700 rounded-lg p-4 text-center"
          >
            <button
              type="button"
              class="mb-2 inline-flex cursor-pointer border-0 bg-transparent p-0"
              aria-label="Reportar alerta temprana"
              (click)="onReportarAlerta()"
            >
              <i
                class="pi pi-exclamation-triangle text-4xl text-yellow-500"
              ></i>
            </button>
            <p class="text-yellow-800 dark:text-yellow-300 mb-3">
              Se identificaron alertas tempranas de riesgo potencial
            </p>
            <button
              pButton
              type="button"
              label="Reportar Alerta Temprana"
              icon="pi pi-external-link"
              class="p-button-warning"
              (click)="onReportarAlerta()"
            ></button>
          </div>
        }
      </div>
    </p-fieldset>
  `,
  styles: [``]
})
export class SeccionRiesgoComponent implements OnInit, OnDestroy {
  // === Inputs ===
  form = input.required<FormGroup>();

  // === Outputs ===
  reportarAlertaTemprana = output<void>();

  // === Estado ===
  // Usar signal en lugar de computed para control directo
  mostrarPanelAlerta = signal(false);

  private subscription?: Subscription;

  ngOnInit(): void {
    // Suscribirse a cambios del control para actualizar el panel
    const f = this.form();
    if (f) {
      const control = f.get('snidentificaRiesgo');
      if (control) {
        // Valor inicial
        this.mostrarPanelAlerta.set(control.value === 'S');
        // Suscribirse a cambios
        this.subscription = control.valueChanges.subscribe((value) => {
          this.mostrarPanelAlerta.set(value === 'S');
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  /**
   * Maneja cambio en radio button de riesgo.
   * Legacy: showPanelInfoRiesgo(visible)
   */
  onRiesgoChange(value: string): void {
    this.mostrarPanelAlerta.set(value === 'S');
  }

  onReportarAlerta(): void {
    this.reportarAlertaTemprana.emit();
  }
}
